import type { PlanKey } from "@mph/launch-control";

interface LiveAppCardProps {
  liveUrl: string;
  availability: "live" | "offline";
  plan?: PlanKey | undefined;
  onAvailabilityChange: (next: "live" | "offline") => void;
  onReplace: () => void;
}

export function LiveAppCard({ liveUrl, availability, plan, onAvailabilityChange, onReplace }: LiveAppCardProps) {
  const isLive = availability === "live";
  const planName = plan === "team" ? "Team" : plan === "solo" ? "Solo" : plan === "free" ? "Free" : null;
  return (
    <section className="live-card" aria-labelledby="live-heading">
      <div className="live-card-heading">
        <span className={`status-dot ${isLive ? "status-live" : "status-offline"}`} aria-hidden="true" />
        <div>
          <span className="eyebrow">{isLive ? "Live" : "Offline"}{planName ? ` · ${planName}` : ""}</span>
          <h2 id="live-heading">Your app has a doorway</h2>
        </div>
      </div>
      <a className="share-link" href={liveUrl} target="_blank" rel="noreferrer">{liveUrl}</a>
      <p className="live-note">{planName
        ? `This app belongs to your ${planName} workspace. Replace the folder anytime without changing the link.`
        : "Replace the folder anytime without changing the link."}</p>
      <div className="button-row">
        <a className="primary-button" href={liveUrl} target="_blank" rel="noreferrer">Open shared app</a>
        <button className="secondary-button" type="button" onClick={onReplace}>Replace folder</button>
        <button
          className="text-button"
          type="button"
          onClick={() => onAvailabilityChange(isLive ? "offline" : "live")}
        >
          {isLive ? "Take offline" : "Put back online"}
        </button>
      </div>
    </section>
  );
}
